export const EMPTY_LICENSE_SELECTION = {
  licenseName: "",
  licenseIdentifier: "",
};

export const getAssetClassificationDefault = (assetClassificationsList = []) => {
  if (assetClassificationsList.length > 0) {
    const defaultAssetClassification = assetClassificationsList.find((item) =>
      item.label.toLowerCase().includes("highest"),
    );
    return defaultAssetClassification?.value || assetClassificationsList[0]?.value;
  }
  return "";
};

export const getDistributionScopeDefault = (distributionScopeList = []) => {
  if (distributionScopeList.length > 0) {
    const defaultDistributionScope = distributionScopeList.find((item) =>
      item.label.toLowerCase().includes("saas"),
    );
    return defaultDistributionScope?.value || distributionScopeList[0]?.value;
  }
  return "";
};

export const getLicensePolicyDefault = (licensePolicyList = []) => {
  if (licensePolicyList.length > 0) {
    return licensePolicyList[0]?.value;
  }
  return "";
};

export const getCompletionRequestDaysDefault = (clientConfig = {}) => {
  const offsetDays = Number(clientConfig?.defaultCompletionRequestDays?.codeValue) || 7;
  const today = new Date();
  const defaultDate = new Date(today);
  if (offsetDays > 0) {
    defaultDate.setDate(today.getDate() + offsetDays);
  }
  return defaultDate;
};

export const buildInitialAddProjectFormData = ({
  productSeq = "",
  assetClassificationsList = [],
  distributionScopeList = [],
  licensePolicyList = [],
  clientConfig = {},
  defaultLicense = null,
} = {}) => ({
  projectName: "",
  productSeq: productSeq ?? "",
  completionRequestDate: getCompletionRequestDaysDefault(clientConfig),
  assetClassification: getAssetClassificationDefault(assetClassificationsList),
  distributionScope: getDistributionScopeDefault(distributionScopeList),
  licensePolicy: getLicensePolicyDefault(licensePolicyList),
  license: "",
  selectedLicense: defaultLicense,
  selectedProjectPreview: null,
  selectedMembers: [],
  projectManagerId: "",
  remark: "",
  selectedFiles: [],
});

export const isAddProjectFormValid = (formData) =>
  Boolean(formData?.projectName?.trim() && formData?.productSeq && formData?.completionRequestDate);

export const buildCreateProjectBody = (formData, canAddProjectMemberPermission) => ({
  projectName: formData.projectName.trim(),
  productSeq: parseInt(formData.productSeq, 10) || null,
  completionRequestDt: formData.completionRequestDate,
  assetClassificationSeq: formData.assetClassification || "",
  distributionScopeCd: formData.distributionScope || "",
  licensePolicySeq: formData.licensePolicy || "",
  licenseName: formData.selectedLicense?.licenseName || "",
  licenseIdentifier: formData.selectedLicense?.licenseIdentifier || "",
  projectPreviewSeq: formData.selectedProjectPreview?.projectPreviewSeq || "",
  projectManagerId: formData.projectManagerId || "",
  remark: formData.remark || "",
  projectMembers: canAddProjectMemberPermission
    ? formData.selectedMembers.map((member) => ({ memberId: member.userId }))
    : [],
  projectId: "",
  openFlag: "Y",
  licenseId: "",
  distributionTargetCd: "",
  licenseClassCd: "COMMERCIAL",
});
